import templateUrl from './component.tpl.html';
import AlQrCodeContentSelectorController from './controller';

angular.module('festzelt-os.modules.core')
    .component('alQrCodeContentSelector', {
        bindings: {
            currentContent: '<',
            onContentChange: '&',
            disabled: '<'
        },
        controller: AlQrCodeContentSelectorController,
        controllerAs: 'vm',
        templateUrl
    })



// WEBPACK FOOTER //
// ./src/app/modules/core/components/al-qr-code-content-selector/component.js